import { useState } from 'react';
import CustomAccordion from '@v2/components/ui/CustomAccordion/CustomAccordion';

import { useGTMItemDispatch } from '@v2/utils/gtm';

import ClickablePDP from '@v2/components/common/presentational/clickables/pdp';
import { useAddPackAction } from '@v2/components/common/products/utils';
import { PackQuantityInput } from '@v2/components/common/products/quantity';
import { useAddCartModal } from '@v2/components/common/presentational/modal/common';

import { WPImage } from '@v2/utils/image';
import arrowUp from '@img/checkout/arrow-up.svg';
import arrowDown from '@img/checkout/arrow-down.svg';
import { useEntity } from '@app/store/rtk.entities.selectors';
import { useCartAllBoxes, usePackBoxIndex } from '@app/store/cart.selectors';

export default function CollaborationBox({ product, disabled }: { product: any, disabled: boolean }) {
    const blueprints = useEntity('blueprints');
    const gtmDispatch = useGTMItemDispatch();
    const addPackAction = useAddPackAction();

    const packBoxIndex = usePackBoxIndex(product.id);
    const [showCartModal] = useAddCartModal(packBoxIndex);
    const [active, setActive] = useState(null);

    const boxes = useCartAllBoxes();

    const select = () => {
        gtmDispatch('select_item', product);
    };

    return (
        <div className="product">
            <div className="product-link horizontal">
                <div style={{ position: 'relative' }}>
                    <ClickablePDP
                        product={product}
                        useHistoryNavigation={true}
                        onBeforeClick={select}>
                        <div className="product-link vertical">
                            <div className="image">
                                <WPImage
                                src={product.mainImage}
                                alt={product.mainImageAlt || product.title}
                                />
                                {(disabled || product.status === 'outofstock')
                                    ?
                                    <></>
                                    :
                                    <div className="tag">Limited time only</div>
                                }
                            </div>
                            <div className="title">
                                {product.title}
                            </div>
                        </div>
                    </ClickablePDP>
                </div>
                <div className="info">
                    <CustomAccordion activeKey={`${active}`} className="lines">
                        <CustomAccordion.Toggle
                            onClick={() => setActive(active === product.id ? null : product.id)}
                            eventKey={`${product.id}`}
                            className={'toggle'}>
                            <span className="regular" style={{ textDecorationLine: 'none' }}>
                                ${product.price.toFixed(2)}
                            </span> | {product.collaboration.size} items
                            <img src={active === product.id ? arrowUp : arrowDown} className={'arrow'} alt="Arrow" />
                        </CustomAccordion.Toggle>
                        <CustomAccordion.Collapse eventKey={`${product.id}`}>
                            <div className={'content'}>
                                {(product && product.collaboration && product.collaboration.size > 0)
                                    ?
                                    <>
                                        <>
                                            {Object.values(product.collaboration.cerebellyProducts).map((line: any, index: number) =>
                                                <div key={index} className="sum-row">
                                                    <div className="caption">
                                                        {line.title} x {line.quantity}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                        <>
                                            {Object.values(product.collaboration.collaborationProducts).map((line: any, index: number) =>
                                                <div key={index} className="sum-row">
                                                    <div className="caption">
                                                        The Dough Project {line.title} x {line.quantity}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    </>
                                    : <></>}
                            </div>
                        </CustomAccordion.Collapse>
                    </CustomAccordion>
                </div>
            </div>
            {(disabled || product?.status === 'outofstock') &&
                <div className="out-of-stock-info" style={{display: 'block'}}>out of stock!</div>
            }
            <div className={`action add ${(disabled || product?.status === 'outofstock') ? 'd-none' : ''}`}>
                <>
                    {boxes[packBoxIndex]
                        ?
                        <PackQuantityInput box={boxes[packBoxIndex]} />
                        :
                        <div className={`action add ${disabled ? 'd-none' : ''}`}>
                            <button
                                className="button primary blue"
                                onClick={() => {
                                    addPackAction(packBoxIndex, product, blueprints, boxes);

                                    showCartModal();
                                }}
                                disabled={disabled}
                                aria-label={'Add to bag'}>
                                {'Add to bag'}
                            </button>
                        </div>
                    }
                </>
            </div>
        </div>
    );
}